/* Define keys for react query */
export const queryKeys = {
  negotiation: "Renegotiation summary",
  vendorQuoteAssessment: "Vendor Quote Assessment",
  userDetails: "User Details",
  volumeAllocation: "Volume Allocation",
  businessCost: "Business Cost",
  businessTrend: "Business Cost Trend",
  costCompliance: "Cost Compliance",
  volumeCompliance: "Volume Compliance",
  volumeComplianceDistricts: "Volume Compliance Districts",
  complianceFilters: "Compliance Filters",
  allocationComplianceFilters: "Allocation Compliance Filters",
  allocationComplianceData: "Allocation Compliance Data",
  home: "Home",
  niaOpportunity: "NIA Opportunity",
  reports: "Reports Data",
  reportFilters: "Report Filters",
  notifications: "Notifications",
  notificaitonsCount: "Notifications Count",
  notificationAll: "Notification All",
  notificationFiltre: "Notification Filter",
  quoteUpload: "Quote Upload",
  quoteDeleteFilter: "Quote Delete Filter",
  quoteDelete: "Quote Delete",
  projectedReleaseUpload: "Projected Release Upload",
  indexUplaod: "Index Uplaod",
  wireContractUpload: "Wire Contract Upload",
  agentPricingUpload: "Agent Pricing Upload",
  screenConfig: "Screen Config",
  reportTrends: "Report Trends",
  reportGrowthVsTm: "Growth Vs TM",
  wireContractDetails: "Wire Contract Details",
  rebateTrackingdetails: "Rebate Tracking",
  spotsContracts: "Spots Contracts",
};
